<script>
import Breadcrumb from '@/components/global/breadcrumb.vue';
import axios from "axios";
import Swal from "sweetalert2";
import Dropdown from 'primevue/dropdown';
import { useGradeStore } from '@/stores/useGradeStore.js';

export default {
  name: "index-exams",
  inject: {
    courseCtx: { default: null },
  },
  data() {
    return {
      gradeSlug: this.$route.params.gradeSlug,
      courseId: this.$route.params.courseId ?? null,
      exams: [],
      lesson: null,
      lessons: [],
      unit: null,
      units: [],
      branch: null,
      branches: [],
      visibilityFilter: null,
      visibilityOptions: [
        { id: 'visible', title: 'ظاهر' },
        { id: 'hidden', title: 'مخفي' },
      ],
    };
  },
  components: {
    Breadcrumb,
    Dropdown
  },
  computed: {
    isCourseScope() { return !!this.courseId; },
    basePath() {
      return this.isCourseScope ? `/courses/${this.courseId}/exams` : `/${this.gradeSlug}/exams`;
    },
    addPath() {
      return this.isCourseScope ? `${this.basePath}/add` : `/${this.gradeSlug}/exam/add`;
    },
    breadcrumbs() {
      if (this.isCourseScope) {
        const base = this.courseCtx?.breadcrumbBase ?? [];
        return [...base, { name: "الامتحانات", path: this.basePath }];
      }
      return [
        { name: 'الرئيسية', path: '/' },
        { name: "الامتحانات", path: this.basePath },
      ];
    },
    gradeStore() { return useGradeStore(); },
    resolvedGrade() {
      const slug = this.gradeSlug;
      return this.gradeStore.activeGrades.find(g => g.slug === slug)
          || this.gradeStore.allGrades.find(g => g.slug === slug)
          || null;
    },
    gradeId() { return this.resolvedGrade?.id ?? null; },
    // Client-side الحالة filter (admin-only convenience). The security-critical
    // student-side filtering is enforced at the DB level in the backend, not here.
    filteredExams() {
      const f = this.visibilityFilter?.id;
      if (!f) return this.exams;
      return this.exams.filter(e => f === 'hidden' ? this.isHidden(e) : !this.isHidden(e));
    },
  },
  methods: {
    // Backend casts `hide` to boolean, but tolerate 1/0/"1" from any older payload.
    isHidden(exam) {
      return exam.hide === true || exam.hide === 1 || exam.hide === '1';
    },

    toggleVisibility(exam) {
      const hiding = !this.isHidden(exam);
      Swal.fire({
        title: hiding ? 'هل أنت متأكد من إخفاء هذا الامتحان؟' : 'هل تريد إظهار هذا الامتحان للطلاب؟',
        text: hiding
          ? 'سيختفي الامتحان من موقع الطلاب ولن يتمكن الطلاب من رؤيته، ولكن سيظل موجودًا في لوحة التحكم.'
          : 'سيظهر الامتحان مرة أخرى للطلاب على الموقع.',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: hiding ? '#d33' : '#3085d6',
        cancelButtonColor: '#6c757d',
        cancelButtonText: 'إلغاء',
        confirmButtonText: hiding ? 'إخفاء الامتحان' : 'إظهار الامتحان',
      }).then((result) => {
        if (!result.isConfirmed) return;
        const fd = new FormData();
        fd.append('exam_id', exam.id);
        fd.append('hide', hiding ? 1 : 0);
        axios.post('exams/hide', fd)
          .then(({ data }) => {
            if (data.status) {
              exam.hide = data.hide;
              const toast = Swal.mixin({
                toast: true, position: 'top-end',
                showConfirmButton: false, timer: 2500, timerProgressBar: true,
              });
              toast.fire({ icon: 'success', title: data.message });
            } else {
              Swal.fire('', data.message, 'error');
            }
          })
          .catch((error) => {
            Swal.fire('', error.response?.data?.message || 'تعذر تحديث حالة الامتحان', 'error');
          });
      });
    },

    fetchQuestions() {
      const params = this.isCourseScope ? { course_id: this.courseId } : { academic_year_id: this.gradeId };
      if (this.lesson?.id) {
        params.lesson_id = this.lesson.id;
      }

      axios
          .get('/exams', { params })
          .then((response) => {
            this.exams = response.data.data;
            // this.paggination = response.data.data.meta.total;
          })
          .catch((error) => {
            this.exams = [];
          });
    },

    deleteQuestion(exam_id) {
      Swal.fire({
        title: "هل تريد الحذف ؟",
        text: "سيتم نقل العنصر إلى سلة المحذوفات ويمكن استرجاعه لاحقاً.",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        cancelButtonText: "رجوع",
        confirmButtonText: "احذف",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
              .delete(`exams/${exam_id}`)
              .then(({ data }) => {
                if (data.status == true) {
                  Swal.fire("تم الحذف بنجاح", "", "success");
                  this.exams = this.exams.filter(r => r.id !== exam_id);
                } else {
                  Swal.fire("", data.message, "error");
                }
              });
        }
      });
    },

    fetchBranch() {
      const params = this.isCourseScope
          ? { type: 1, course_id: this.courseId }
          : { type: 1, academic_year_id: this.gradeId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.branches = response.data.data; })
          .catch(() => {});
    },
    fetchUnits() {
      const branchId = this.branch?.id;
      const params = this.isCourseScope
          ? { type: 2, course_id: this.courseId, parent_id: branchId }
          : { type: 2, academic_year_id: this.gradeId, parent_id: branchId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.units = response.data.data; })
          .catch(() => {});
    },
    fetchLessons() {
      const unitId = this.unit?.id;
      const params = this.isCourseScope
          ? { type: 3, course_id: this.courseId, parent_id: unitId }
          : { type: 3, academic_year_id: this.gradeId, parent_id: unitId };
      axios
          .get('/lessons', { params })
          .then((response) => { this.lessons = response.data.data; })
          .catch(() => {});
    },

    customLabelBranch(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelUnit(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
    customLabelLesson(option) {
      return option ? (option.description ? `${option.title} (${option.description})` : option.title) : '';
    },
  },
  async mounted() {
    if (!this.isCourseScope) {
      if (!this.gradeStore.activeGrades.length) await this.gradeStore.fetchActiveGrades();
      if (!this.gradeStore.allGrades.length) await this.gradeStore.fetchAllGrades();
    }
    this.fetchQuestions();
    this.fetchBranch();
  }
}
</script>

<template>
  <Breadcrumb :items="breadcrumbs" />
  <div class="container-fluid my-3">
    <div class="filter my-3">
      <div class="filter-head">
        <div class="row d-flex align-items-center gap-4 w-75">
          <h4 class="mb-0 col-lg-2 col-12">الامتحانات</h4>
          <div class="row d-flex gap-lg-0 gap-2 col-lg-10 col-12 mb-lg-0 mb-2">
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="branch" :options="branches" showClear :optionLabel="customLabelBranch" placeholder="اختر الفرع" class="w-full md:w-14rem" @update:model-value="fetchUnits" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="unit" :options="units" showClear :optionLabel="customLabelUnit" placeholder="اختر الوحده" class="w-full md:w-14rem" @update:model-value="fetchLessons" />
              </div>
            </div>
            <div class="col-lg-4 col-md-6 col-12">
              <div class="d-flex flex-column gap-2">
                <Dropdown v-model="lesson" :options="lessons" showClear :optionLabel="customLabelLesson" placeholder="اختر الدرس" class="w-full md:w-14rem" @update:model-value="fetchQuestions" />
              </div>
            </div>
          </div>
        </div>
        <div class="buttons">
          <Dropdown v-model="visibilityFilter" :options="visibilityOptions" showClear optionLabel="title"
                    placeholder="الحالة" class="visibility-filter" />
          <router-link :to="addPath" class="btn PrimaryButton">إضافة امتحان</router-link>
        </div>
      </div>
    </div>
    <div class="row reservation-table">
      <div class="col-12">
        <div class="table-responsive">
          <table class="table table-striped">
            <thead>
            <tr>
              <th scope="col">#</th>
              <th scope="col">الصورة</th>
              <th scope="col">العنوان</th>
              <th scope="col">التاريخ</th>
              <th scope="col">درجة الامتحان</th>
              <th scope="col">صعوبة السؤال</th>
              <th scope="col">الدرس</th>
              <th scope="col">الحالة</th>
              <th scope="col">التحكم</th>
            </tr>
            </thead>
            <tbody>
            <tr
                v-for="(exam, index) in filteredExams"
                :key="exam.id"
            >
              <td data-label="ID">{{ index + 1 }}</td>
              <td data-label="الصورة">
                <img v-if="exam.image" :src="exam.image" alt="exam Image" style="width: 50px; height: 50px; object-fit: cover; border-radius: 5px;" />
                <span v-else>--- </span>
              </td>
              <td data-label="الاسم">{{ exam.title }}</td>
              <td data-label="التاريخ">{{ exam.date }}</td>
              <td data-label=">درجة الامتحان">{{ exam.total_degree }}</td>
              <td data-label="صعوبة السؤال">
                <span v-if="exam.difficulty_level === 'easy'">سهل</span>
                <span v-else-if="exam.difficulty_level === 'medium'">متوسط</span>
                <span v-else-if="exam.difficulty_level === 'hard'">صعب</span>
              </td>
              <td data-label="الدرس">{{ exam.lesson ? exam.lesson?.title : '---' }}</td>
              <td data-label="الحالة">
                <span v-if="isHidden(exam)" class="status-badge status-badge--blocked">مخفي</span>
                <span v-else class="status-badge status-badge--accepted">ظاهر</span>
              </td>
              <td data-label="التحكم">
                <button class="btn text-white mx-1"
                        type="button"
                        :class="isHidden(exam) ? 'btn-secondary' : 'btn-info'"
                        :tooltip="isHidden(exam) ? 'إظهار الامتحان' : 'إخفاء الامتحان'"
                        flow="up"
                        @click="toggleVisibility(exam)">
                  <i :class="isHidden(exam) ? 'pi pi-eye-slash' : 'pi pi-eye'"></i>
                </button>
                <router-link class="btn btn-success text-white mx-1"
                             :tooltip="'تقارير الامتحان'"
                             flow="up"
                             :to="isCourseScope ? `${basePath}/${exam.id}/report` : `/${gradeSlug}/exam/${exam.id}/report`">
                  <i class="pi pi-chart-bar"></i>
                </router-link>
                <router-link class="btn btn-primary text-white mx-1"
                             :tooltip="'تعديل'"
                             flow="up"
                             :to="isCourseScope ? `${basePath}/edit/${exam.id}` : `/${gradeSlug}/exam/edit/${exam.id}`">
                  <i class="pi pi-pencil"></i>
                </router-link>
                <button class="btn btn-danger text-white mx-1"
                        type="button"
                        :tooltip="`حذف`"
                        flow="up"
                        @click="deleteQuestion(exam.id)">
                  <i class="pi pi-trash"></i>
                </button>
              </td>
            </tr>
            <tr v-if="filteredExams.length === 0">
              <td colspan="9" class="text-center">لا يوجد بيانات</td>
            </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.visibility-filter {
  min-width: 9rem;
  margin-inline-end: 0.5rem;
}
</style>